<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Ship Management Company" subTitle="Forms" />

    <ListShipManagementCompany />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListShipManagementCompany from "@/components/Pages/Master/ShipManagementCompany/ListShipManagementCompany.vue";

export default defineComponent({
  name: "ListShipManagementCompanyPage",
  components: {
    PageTitle,
    ListShipManagementCompany,
  },
});
</script>
